module.exports = __webpack_public_path__ + "static/media/belcolor__4.235db497.jpg";